var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4753 19.3641V22.0308C14.3535 22.0308 12.3187 22.8736 10.8184 24.3739C9.31812 25.8742 8.47526 27.909 8.47526 30.0308H5.80859C5.80859 27.2018 6.9324 24.4887 8.93279 22.4883C10.9332 20.4879 13.6463 19.3641 16.4753 19.3641ZM16.4753 18.0308C12.0553 18.0308 8.47526 14.4508 8.47526 10.0308C8.47526 5.61076 12.0553 2.03076 16.4753 2.03076C20.8953 2.03076 24.4753 5.61076 24.4753 10.0308C24.4753 14.4508 20.8953 18.0308 16.4753 18.0308ZM16.4753 15.3641C19.4219 15.3641 21.8086 12.9774 21.8086 10.0308C21.8086 7.0841 19.4219 4.69743 16.4753 4.69743C13.5286 4.69743 11.1419 7.0841 11.1419 10.0308C11.1419 12.9774 13.5286 15.3641 16.4753 15.3641Z",
    fill: "#0D458A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7697 18.8833L25.2072 23.3073H29.8589L26.0956 26.0415L27.533 30.4656L23.7697 27.7314L20.0064 30.4656L21.4439 26.0415L17.6805 23.3073H22.3323L23.7697 18.8833Z",
    fill: "#3AA64C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserblue);
export default __webpack_public_path__ + "static/media/userblue.6a1094ac5acf4dacf06ffab4977112b8.svg";
export { ForwardRef as ReactComponent };